The response from the `postPositionFromDraft` mutation.
